// FR
export const reservasHc = {
  // ── CheckinsList.vue ──────────────────────────────────────────────────────
  checkinsList: {
    newCheckin: "Nouveau check-in",
    manualDispatchTitle: "Clôture manuelle de l'envoi final",
    manualDispatchText:
      "Si l'un des voyageurs ne se présente pas, vous pouvez clôturer manuellement ce processus pour envoyer maintenant le message de bienvenue, les clés numériques et le document au responsable de la réservation.",
    sending: "Envoi en cours...",
    completeManualSend: "Clôturer manuellement et envoyer",
    finalSendProcessed: "Envoi final déjà traité",
    arrivalInstructions: "Instructions d'arrivée",
    arrivalAlreadySent: "Déjà envoyées. Vous pouvez les renvoyer au voyageur maintenant si nécessaire.",
    arrivalAutoInfo:
      "Elles sont envoyées automatiquement à l'heure prévue. Vous pouvez les anticiper et les envoyer maintenant (message, accès et fichiers configurés).",
    resendNow: "Renvoyer maintenant",
    sendNow: "Envoyer maintenant",

    titleEditCheckin: "Modifier le check-in",
    titleDeleteCheckin: "Supprimer le check-in",

    confirmManualTitle: "Terminer l'envoi manuellement ?",
    confirmManualMsg:
      "Utilisez cette action lorsqu'il n'y aura plus de voyageurs à enregistrer et que vous devez envoyer maintenant les informations finales au responsable de la réservation.",
    yesSendNow: "Oui, envoyer maintenant",
    cancel: "Annuler",
    manualSendFailed: "Impossible de terminer l'envoi manuel.",
    sendProcessedTitle: "Envoi traité",
    finalInfoProcessed: "Les informations finales du check-in ont déjà été traitées.",
    couldNotSend: "Impossible d'envoyer",

    confirmResendArrivalTitle: "Renvoyer les instructions d'arrivée ?",
    confirmSendArrivalTitle: "Envoyer les instructions d'arrivée maintenant ?",
    confirmResendArrivalMsg:
      "Les instructions d'arrivée ont déjà été envoyées. Voulez-vous les renvoyer au voyageur maintenant ?",
    confirmSendArrivalMsg:
      "Les instructions d'arrivée (message, accès et fichiers configurés) seront envoyées au voyageur maintenant, sans attendre l'heure prévue.",
    arrivalSendFailed: "Impossible d'envoyer les instructions d'arrivée.",
    pendingDeliveryTitle: "En attente de livraison",
    instructionsSentTitle: "Instructions envoyées",
    arrivalSentToGuest: "Les instructions d'arrivée ont été envoyées au voyageur.",

    stepGuestData: "Données du voyageur",
    stepSignature: "Signature",
    stepRegistered: "Check-in enregistré",

    sectionPersonal: "Données personnelles",
    sectionStay: "Séjour",
    sectionDocument: "Document",

    nombre: "Prénom",
    apellido: "Nom",
    sexo: "Sexe",
    select: "Sélectionnez",
    male: "Masculin",
    female: "Féminin",
    preferNotToSay: "Je préfère ne pas répondre",
    other: "Autre",
    birthDate: "Date de naissance",
    minorsTraveling: "Des mineurs voyagent-ils sur cette réservation ?",
    no: "Non",
    yes: "Oui",
    relationshipMinor: "Lien de parenté du mineur",
    relationshipToMinor: "Lien de parenté avec le mineur",
    phone: "Téléphone",
    email: "E-mail",
    checkInDate: "Date d'arrivée",
    checkOutDate: "Date de départ",

    nationality: "Nationalité",
    cittadinanza: "Cittadinanza / Nationalité",
    documentType: "Type de document",
    documentNumber: "Numéro de document",
    supportNumber: "Numéro de support",
    docTypes: {
      passport: "Passeport",
      identityDoc: "Pièce d'identité",
      co_cc: "Carte de citoyenneté",
      co_ce: "Carte d'étranger",
      co_ppt: "Permis de protection temporaire",
      co_pep: "Permis spécial de séjour",
      co_de: "Document étranger",
    },
    relationships: {
      co: {
        PADRE: "Père",
        MADRE: "Mère",
        HIJO: "Fils/Fille",
        ABUELO: "Grand-père/Grand-mère",
        HERMANO: "Frère/Sœur",
        TIO: "Oncle/Tante",
        TUTOR: "Tuteur/Tutrice légal(e)",
        OTRO: "Autre",
      },
      es: {
        HJ: "Fils/Fille",
        AB: "Grand-père/Grand-mère",
        BA: "Arrière-grand-père/mère",
        BN: "Arrière-petit(e)-enfant",
        CD: "Beau-frère/Belle-sœur",
        CY: "Conjoint(e)",
        HR: "Frère/Sœur",
        NI: "Petit(e)-enfant",
        OT: "Autre",
        PM: "Père/Mère",
        SB: "Neveu/Nièce",
        SG: "Beau-père/Belle-mère",
        TI: "Oncle/Tante",
        TU: "Tuteur/Tutrice",
        YN: "Gendre/Belle-fille",
      },
    },

    italyBannerTitle: "Données requises en Italie · Alloggiati Web",
    italyBannerText:
      "La Polizia di Stato exige l'État de naissance, la commune de naissance et le lieu de délivrance du document.",
    sectionBirthData: "Données de naissance",
    statoNascita: "Stato di nascita / Pays de naissance",
    birthStateHint: "L'État de naissance peut différer de la nationalité.",
    comuneNascita: "Commune de naissance",
    luogoRilascio: "Lieu de délivrance du document",
    luogoRilascioHint: "Commune italienne ou État étranger qui a délivré le document.",
    searchCittadinanza: "Rechercher la nationalité…",
    searchStatoNascita: "Rechercher l'État de naissance…",
    searchComuneNascita: "Rechercher la commune de naissance…",
    searchComuneRilascio: "Commune de délivrance…",
    searchStatoRilascio: "État de délivrance…",

    sectionSes: "Données SES Hospedajes",
    countryResidence: "Pays de résidence",
    cityResidence: "Ville de résidence",
    address: "Adresse",
    zipCode: "Code postal",
    paymentMethod: "Mode de paiement",
    paymentDate: "Date de paiement",
    pay: {
      efectivo: "Espèces",
      destino: "Paiement à destination",
      tarjeta: "Carte",
      movil: "Paiement mobile",
      plataforma: "Plateforme",
      transferencia: "Virement",
    },

    sireLegalTitle: "SIRE & TRA — Mentions légales",
    sireLegalText:
      "Pour les établissements en Colombie, les informations demandées sont collectées conformément à la réglementation de Migración Colombia (SIRE) et au registre des voyageurs (TRA).",
    sectionSire: "Données SIRE / TRA",
    searchNationality: "Rechercher une nationalité...",
    searchCountry: "Rechercher un pays...",
    noResults: "Aucun résultat",
    countryOrigin: "Pays de provenance",
    searchCountryOrigin: "Rechercher un pays de provenance...",
    cityOrigin: "Ville de provenance",
    searchCity: "Rechercher une ville...",
    searchMunicipality: "Rechercher une commune...",
    nextDestinationCountry: "Pays de prochaine destination",
    searchDestinationCountry: "Rechercher un pays de destination...",
    summaryOrigin: "Provenance",
    summaryDestination: "Destination",

    sectionIdentity: "Vérification d'identité",
    recommended: "recommandé",
    identityActiveInfo:
      "L'établissement a la vérification d'identité activée. Téléversez des photos du document du voyageur.",
    documentFront: "Recto du document",
    uploadPhoto: "Téléverser une photo",
    selfieGuest: "Selfie du voyageur",
    altDocumentFront: "Recto du document",
    altMinorAuth: "Autorisation du mineur",
    titleRemove: "Supprimer",

    sectionMinorDocs: "Documentation du mineur",
    optional: "facultatif",
    minorInfo: "Pour les mineurs, vous pouvez téléverser l'autorisation de voyage ou le document du tuteur.",
    guardianAuthDoc: "Autorisation / Document du tuteur",
    uploadDocument: "Téléverser un document",

    sectionSignature: "Signature du voyageur",
    signatureHint: "Demandez au voyageur de signer dans le cadre pour accepter les conditions de l'établissement.",
    undo: "Défaire",
    clear: "Effacer",
    termsAccept: "Le voyageur accepte les conditions générales de l'établissement",

    successTitle: "Check-in enregistré !",
    successBefore: "Le check-in de",
    successAfter: "a bien été enregistré.",

    next: "Suivant",
    back: "Retour",
    saving: "Enregistrement...",
    saveCheckin: "Enregistrer le check-in",
    close: "Fermer",

    vNombre: "Le prénom est obligatoire",
    vApellido: "Le nom est obligatoire",
    vSexo: "Le sexe est obligatoire",
    vBirthDate: "La date de naissance est obligatoire",
    vPhone: "Le téléphone est obligatoire",
    vCheckIn: "La date d'arrivée est obligatoire",
    vCheckOut: "La date de départ est obligatoire",
    vNationality: "La nationalité est obligatoire",
    vDocType: "Le type de document est obligatoire",
    vDocNumber: "Le numéro de document est obligatoire",
    vEmailFormat: "L'e-mail n'a pas un format valide",
    vDocSupport: "Le numéro de support du document est obligatoire",
    vMinors: "Indiquez si des mineurs voyagent sur la réservation",
    vRelationship: "Le lien de parenté du mineur accompagné est obligatoire",
    vCountryResidence: "Le pays de résidence est obligatoire",
    vCityResidence: "La ville de résidence est obligatoire",
    vAddress: "L'adresse est obligatoire",
    vZip: "Le code postal est obligatoire",
    vPaymentMethod: "Le mode de paiement est obligatoire",
    vPaymentDate: "La date de paiement est obligatoire",
    vCountryOrigin: "Le pays de provenance est obligatoire",
    vNextDest: "Le pays de prochaine destination est obligatoire",
    vCityOrigin: "La ville de provenance est obligatoire",
    vStatoNascita: "L'État de naissance (Stato di nascita) est obligatoire",
    vComuneNascita: "La commune de naissance (Comune di nascita) est obligatoire",
    vLuogoRilascio: "Le lieu de délivrance du document (Luogo di rilascio) est obligatoire",

    vTerms: "Vous devez accepter les conditions pour continuer",
    vSignaturePad: "Erreur d'accès au panneau de signature",
    vSignature: "La signature est obligatoire",
    saveCheckinError: "Une erreur s'est produite lors de l'enregistrement du check-in",
    saveCheckinErrorGeneric: "Erreur lors de l'enregistrement du check-in",
    socketCheckinDone: "<strong>{name}</strong> a effectué le check-in manuel",
    identityPhotosError: "Le check-in a été enregistré, mais les photos d'identité n'ont pas pu être téléversées",
    minorAuthError: "Le check-in a été enregistré, mais l'autorisation du mineur n'a pas pu être téléversée",

    docDni: "DNI invalide. Il doit comporter 8 chiffres suivis de la lettre de contrôle correcte (ex : 12345678Z)",
    docNie: "NIE invalide. Format : X/Y/Z + 7 chiffres + lettre de contrôle (ex : X1234567Z)",
    docPassport: "Passeport invalide. Il doit comporter entre 6 et 20 caractères alphanumériques",
    docCc: "Carte de citoyenneté invalide. Elle doit comporter entre 6 et 10 chiffres",
    docCe: "Carte d'étranger invalide. Elle doit comporter entre 6 et 12 caractères alphanumériques",
    docPptPep: "{tipo} invalide. Il doit comporter entre 4 et 15 caractères alphanumériques",

    zipNotFound: "Code postal introuvable. Vérifiez le numéro et réessayez.",
  },

  // ── PageReservation.vue ───────────────────────────────────────────────────
  pageReservation: {
    requestPendingTitle: "Demande de réservation en attente",
    requestPendingText:
      "Le voyageur a demandé ces dates. Le calendrier n'est pas bloqué tant que vous n'avez pas approuvé.",
    approving: "Approbation…",
    approve: "Approuver",
    rejecting: "Refus…",
    reject: "Refuser",
    requestRejectedTitle: "Demande refusée",
    requestRejectedText: "Cette demande a été refusée par l'établissement et ne peut plus être confirmée.",
    awaitingPaymentTitle: "En attente du paiement du voyageur",
    awaitingPaymentText:
      "Le calendrier est bloqué temporairement. En l'absence de paiement, la disponibilité est libérée automatiquement.",
    remaining: "restant",
    marking: "Marquage...",
    markAsPaid: "Marquer comme payée",
    expiring: "Expiration...",
    markAsExpired: "Marquer comme expirée",

    extensionPendingTitle: "Prolongation de séjour en attente",
    extraNights: "{count} nuit(s) supplémentaire(s)",
    newCheckout: "nouveau départ",
    awaitingGuestPayment: "en attente du paiement du voyageur",
    holdLeftMinutes: "il reste {min} min pour payer",
    holdLeftSeconds: "il reste {seg} s pour payer",
    holdExpired: "le délai a expiré : les nuits ont été libérées",
    pendingApproval: "en attente d'approbation",
    confirming: "Confirmation...",

    observation: "Remarque",

    pendingCharge: "en attente d'encaissement",
    processing: "Traitement...",

    clientRequested: "Le client a demandé :",
    serviceFallback: "Service",
    toConsult: "sur demande",

    approveRequestTitle: "Approuver la demande",
    amountToCharge: "Montant à facturer",
    noCharge: "0 = sans frais",
    approveHint:
      "Si vous avez une passerelle connectée, un <strong>lien de paiement</strong> est envoyé au voyageur (WhatsApp + e-mail). Sinon, il lui est indiqué qu'il <strong>paiera à l'arrivée</strong>.",
    cancel: "Annuler",
    close: "Fermer",
    approveAndNotify: "Approuver et prévenir",

    reservationTotal: "Total de la réservation :",
    onRequestPaidSeparately: `les éléments "sur demande" sont payés à part`,
    fullPayment: "Paiement total",
    noBalance: "(sans solde)",
    deposit: "Acompte",
    balance: "solde",
    markPaidHint: `Le montant choisi est enregistré comme encaissé. Le "total" couvre le séjour, le ménage et les services payants (par ex. Uber) ; les éléments "sur demande" ont leur propre encaissement.`,
    confirm: "Confirmer",

    paymentExpiredTitle: "Délai de paiement expiré",
    paymentExpiredText: "La réservation temporaire a expiré et la disponibilité a été libérée automatiquement.",

    overbookingTitle: "Réservation en surréservation",
    overbookingText:
      "Ses dates entrent en conflit avec une autre réservation de cet établissement. Les dates restent bloquées sur les OTA. Si vous avez déjà résolu le conflit (annulé ou déplacé l'autre réservation), confirmez-la ici.",
    verifying: "Vérification...",
    confirmReservation: "Confirmer la réservation",

    checkinInvitation: "Invitation au check-in",
    copyCheckinLink: "Copier le lien de check-in",
    editReservation: "Modifier la réservation",

    codesAndAccess: "Codes et accès",
    codesAndAccessSub: "Codes et liens d'accès du voyageur",
    currentAccessCodes: "Codes d'accès actuels :",
    currentAccessCode: "Code d'accès actuel :",
    guestDigitalAccess: "Accès numérique du voyageur",
    copyOpenLink: "Copier le lien d'ouverture",
    copy: "Copier",
    openLink: "Ouvrir le lien d'ouverture",
    open: "Ouvrir",
    yacanNote: "L'accès de cette réservation est géré par <b>YACAN</b> automatiquement avec ses serrures.",
    digitalKeyEkey: "Clé numérique (ekey)",
    openDigitalKey: "Ouvrir la clé numérique",
    previousCodesExpired: "Codes précédents (déjà expirés) :",
    sentOn: "envoyé le",
    generated: "généré",
    expiredOn: "expiré le",

    amountAndPayment: "Montant et paiement",
    amountAndPaymentSub: "Détail, statut de l'encaissement et facturation",

    guestJourney: "Parcours du voyageur",
    eventsCount: "{count} événement | {count} événements",
    journeySubtitle: "Traçabilité complète de la réservation au départ",
    stagesCompleted: "étapes terminées",
    nextLabel: "Prochaine :",
    // Cabecera del bloque de etapas que aún no han ocurrido; van FUERA de la cronología.
    pendingAhead: "Ce qu'il reste",
    // El envío del parte a las autoridades: cada servicio lo apunta en historial_firmas.
    authoritiesTitle: "Fiche de police",
    authoritiesAction: "a été déclaré aux autorités",
    authoritiesDesc: "Envoyé à {services}",
    viewInChat: "Voir dans le chat",

    accessCode: "Code d'accès",
    accessCodeSub: "Modifiez et envoyez le code au voyageur",
    currentlyConfiguredCode: "Code actuellement configuré",
    newCode: "Nouveau code",
    keepSameToResend: "laissez-le identique pour renvoyer sans modifications",
    placeholderCode: "Ex : ABCD1234",
    codeSavedUppercaseHint: "Le code sera enregistré en majuscules et envoyé par WhatsApp et/ou e-mail.",
    sending: "Envoi en cours...",
    saveAndSendToGuest: "Enregistrer et envoyer au voyageur",

    resendAccess: "Renvoyer l'accès",
    sendAccess: "Envoyer l'accès",
    resendPin: "Renvoyer le PIN",
    sendPin: "Envoyer le PIN",
    activating: "Activation...",
    resendCode: "Renvoyer le code",
    sendAccessCode: "Envoyer le code d'accès",

    channelManager: "channel manager",
    directBooking: "réservation directe",
    directTag: "Directe",
    bookingRegistered: "Réservation enregistrée",
    bookedViaOta: "a réservé via une OTA",
    createdBooking: "a créé la réservation",
    incomingVia: "Entrante via {channel}",
    confirmedTag: "Confirmée",
    pendingTag: "En attente",
    bookingConfirmed: "Réservation confirmée",
    pendingConfirmation: "En attente de confirmation",
    receivedConfirmation: "a reçu la confirmation de sa réservation",
    awaitingConfirmationAction: "est en attente de confirmation",
    propertyConfirmed: "L'établissement a confirmé la réservation",
    awaitingConfirmationDesc: "En attente de confirmation",
    sentTag: "Envoyée",
    notSentTag: "Non envoyée",
    checkinInvitationTitle: "Invitation au check-in",
    receivedCheckinInvite: "a reçu l'invitation au check-in",
    notReceivedCheckinInvite: "n'a pas encore reçu l'invitation au check-in",
    checkinLinkSent: "Lien de check-in envoyé au voyageur",
    inviteNotSentYet: "L'invitation n'a pas encore été envoyée",
    completedTag: "Terminé",
    checkinOnline: "Check-in en ligne",
    didCheckinOnline: "a effectué le check-in en ligne",
    notYetCheckinOnline: "n'a pas encore effectué le check-in en ligne",
    guestsRegistered: "{count} voyageur(s) enregistré(s)",
    guestNotCompletedCheckin: "Le voyageur n'a pas encore terminé le check-in",
    sentTagPlural: "Envoyés",
    accessCodes: "Codes d'accès",
    receivedAccessCodes: "a reçu les codes d'accès",
    notReceivedAccessCodes: "n'a pas encore reçu les codes d'accès",
    accessKeysSent: "Codes d'accès envoyés au voyageur",
    pendingSendAccess: "En attente d'envoi des accès",
    finishedTag: "Terminée",
    plannedTag: "Prévu",
    guestCheckout: "Départ du voyageur",
    finishedStay: "a terminé son séjour",
    plannedCheckout: "a un départ prévu",
    stayFinished: "Le séjour est terminé",
    autoCheckoutScheduled: "Check-out automatique programmé",
    theGuest: "Le voyageur",
    theTeam: "L'équipe",
    theChannel: "Le canal",
    theSystem: "Le système",
    calledFromNumber: "a appelé depuis le numéro {phone}",

    filterAll: "Tout",
    filterWhatsapp: "WhatsApp",
    filterCalls: "Appels",
    filterCheckin: "Check-in",
    filterAccess: "Accès",
    filterBooking: "Réservation",

    error: "Erreur",
    requestApprovedMsg: "Demande approuvée. La réservation est confirmée.",
    requestApprovedTitle: "✓ Approuvée",
    couldNotApprove: "Impossible d'approuver.",
    confirmRejectRequestMsg: "Êtes-vous sûr de vouloir refuser cette demande ? Cette action est irréversible.",
    rejectRequestHeader: "Refuser la demande",
    yesReject: "Oui, refuser",
    requestRejectedMsg: "Demande refusée.",
    rejectedTitle: "Refusée",
    couldNotReject: "Impossible de refuser.",
    couldNotLoadOptions: "Impossible de charger les options ; le total sera marqué.",
    noticeTitle: "Avis",
    depositMarkedPaid: "Acompte marqué comme payé. Réservation confirmée avec un solde restant.",
    fullMarkedPaid: "Réservation marquée comme payée en totalité et confirmée.",
    paymentConfirmedTitle: "Paiement confirmé",
    couldNotMarkPaid: "Impossible de marquer comme payée.",
    tempReservationExpired: "La réservation temporaire a été expirée et a libéré la disponibilité.",
    reservationExpiredTitle: "Réservation expirée",
    couldNotMarkExpired: "Impossible de marquer comme expirée.",
    extensionMarkedPaid: "La prolongation a été marquée comme payée et confirmée.",
    extensionConfirmedTitle: "Prolongation confirmée",
    couldNotConfirmExtension: "Impossible de confirmer la prolongation.",
    extensionCancelled: "La prolongation a été annulée et la disponibilité a été libérée.",
    extensionRejectedTitle: "Prolongation refusée",
    couldNotRejectExtension: "Impossible de refuser la prolongation.",
    chargeMarkedPaid: "Le frais a été marqué comme payé.",
    chargeRegisteredTitle: "Encaissement enregistré",
    couldNotMarkChargePaid: "Impossible de marquer le frais comme payé.",
    chargeRejected: "Le frais a été refusé et retiré de la réservation.",
    chargeRejectedTitle: "Frais refusé",
    couldNotRejectCharge: "Impossible de refuser le frais.",
    approvedState: "Approuvé",
    rejectedState: "Refusé",
    paidState: "Payé",
    pendingYourResponse: "En attente de votre réponse",
    enterValidAmount: "Indiquez un montant valide (0 = sans frais).",
    amountTitle: "Montant",
    approvedPaymentLinkSent: "Approuvée. Le lien de paiement a été envoyé au voyageur (WhatsApp + e-mail).",
    serviceApprovedTitle: "Service approuvé",
    approvedPayOnArrival: "Approuvée. Le voyageur paiera à l'arrivée (aucune passerelle connectée).",
    approvedGuestNotified: "Approuvée. Le voyageur a été prévenu.",
    couldNotApproveRequest: "Impossible d'approuver la demande.",
    requestRejectedNotified: "Demande refusée. Le voyageur a été prévenu.",
    serviceRejectedTitle: "Service refusé",
    couldNotRejectRequest: "Impossible de refuser la demande.",
    resendAccessLinkMsg: "Voulez-vous renvoyer le lien d'accès via les canaux disponibles ?",
    sendAccessLinkMsg: "Voulez-vous envoyer le lien d'accès via les canaux disponibles ?",
    resendPinMsg:
      "Voulez-vous renvoyer le code d'accès via les canaux disponibles ? Un nouveau PIN sera généré.",
    sendPinMsg: "Voulez-vous générer et envoyer le code d'accès via les canaux disponibles ?",
    sendDigitalAccessHeader: "Envoyer l'accès numérique",
    sendPinHeader: "Envoyer le PIN d'accès",
    send: "Envoyer",
    accessLinkSent: "Lien d'accès envoyé au voyageur",
    accessSentTitle: "Accès envoyé",
    successSummary: "Succès",
    digitalAccessSentDetail: "L'accès numérique a été envoyé pour {count} appareil(s)",
    ttlockCodesGenerated: "{count} codes TTLock ont été générés et traités pour la réservation.",
    accessCodeResent: "Code d'accès renvoyé : {code}",
    accessCodeGeneratedSent: "Code d'accès généré et envoyé : {code}",
    pinSentTitle: "PIN envoyé",
    pinProcessedDetail: "Le PIN a été traité pour {count} serrure(s)",
    pinProcessedBlebox: "et {count} porte(s) électronique(s)",
    couldNotSendAccessCode: "Impossible d'envoyer le code d'accès",
    codeCopied: "Code copié dans le presse-papiers",
    mainGate: "Portail principal",
    accommodation: "Logement",
    doorLabel: "Porte du logement",
    validUntil: "Valable jusqu'au : {date}",
    earlyAccessLinkMsg:
      "Cela activera le lien d'accès immédiatement (avant l'heure normale de check-in).",
    earlyAccessPinMsg: "Cela activera le PIN immédiatement (avant l'heure normale de check-in).",
    earlyAccessHeader: "Accès anticipé",
    activate: "Activer",
    earlyAccessActivated: "Accès anticipé activé",
    okSummary: "OK",
    earlyAccessActivatedDetail: "L'accès anticipé a été activé",
    couldNotActivateEarlyAccess: "Impossible d'activer l'accès anticipé",
    cancelReservationMsg:
      "La réservation sera entièrement annulée. Si elle occupe plusieurs chambres (même de types différents), elles seront toutes annulées et libérées. Cette action est irréversible.",
    goBack: "Retour",
    resolveOverbookingMsg:
      "Il sera vérifié qu'il n'y a plus de conflit avec une autre réservation. Si elle est libre, la réservation passera à confirmée et ses dates resteront bloquées sur les OTA.",
    confirmOverbookingHeader: "Confirmer la réservation en surréservation",
    reservationConfirmed: "Réservation confirmée.",
    couldNotConfirmReservation: "Impossible de confirmer la réservation.",
    reservationCancelledFreed: "Réservation annulée. {count} chambres ont été libérées.",
    otaLangPrompt:
      "Cette réservation OTA n'a pas de téléphone. Indiquez la langue du message pour envoyer le check-in via le chat de l'OTA : es, en, fr, pt, ar, it, de",
    inviteProcessedEmailOta: "Invitation traitée. Également envoyée par e-mail et chat OTA.",
    inviteProcessedOta: "Invitation traitée. Également envoyée par chat OTA.",
    inviteProcessedEmail: "Invitation traitée. Également envoyée par e-mail.",
    couldNotSendCheckinInvite: "Impossible d'envoyer l'invitation au check-in",
    couldNotLoadConversations: "Impossible de charger les conversations",
    reservationUpdatedShort: "Réservation mise à jour",
    couldNotUpdateReservation: "Impossible de mettre à jour la réservation",
    codeEmpty: "Le code ne peut pas être vide",
    attentionTitle: "Attention",
    accessCodeProcessed: "Code d'accès traité avec succès",
    sentCheckTitle: "Envoyé ✓",
    accessCodeSendProcessed: "L'envoi du code d'accès a été traité.",
    couldNotSendCode: "Impossible d'envoyer le code",
    chatOta: "chat OTA",
    emailChannel: "e-mail",
    channelsUsed: "Canaux utilisés : {channels}.",
  },

  // ── HotelReservationModal.vue ─────────────────────────────────────────────
  telefonoDelHuesped: {
    noValido: "Ce numéro ne semble pas valide pour {pais}. Si le client vient d'un autre pays, changez le drapeau. Appuyez à nouveau sur enregistrer pour le garder quand même.",
  },
  hotelResModal: {
    otaBanner:
      "Réservation OTA : vous ne pouvez pas modifier les <strong>dates</strong>, le <strong>type</strong> ni la <strong>quantité de chambres</strong> depuis WA Checkin. Vous devez le faire depuis l'OTA (Booking, Airbnb, etc.).",
    otaLock: "Réservation OTA : les dates, le type et la quantité ne peuvent être modifiés que depuis l'OTA.",
    close: "Fermer",
    placeholderEmail: "email@exemple.com",
    roomAbbr: "Ch.",
    fromCalendar: "depuis le calendrier",
    noMatches: "Aucune correspondance",
    undo: "Rétablir",
    removeRoom: "Retirer la chambre",
    willBeRemovedOnSave: "Sera retirée lors de l'enregistrement des modifications.",
    checkingAvailability: "Vérification de la disponibilité…",
    availableCount: "{count} disponible | {count} disponibles",
    notEnoughAvail: "Disponibilité insuffisante",
    freeCount: "{count} libre | {count} libres",
    total: "total",
    nightsCount: "{count} nuit | {count} nuits",
    resendConfirmationTitle: "Renvoyer le message de confirmation",
    resendConfirmationSub: "Renvoyer le modèle de confirmation au voyageur.",
    resendConfirmationNote:
      "Lors de la modification de la réservation, le <strong>modèle de confirmation</strong> de cette réservation sera renvoyé.",
    room: "Chambre",

    noEnoughUnitsFree: "Disponibilité insuffisante. Unités libres : {units}.",
    closedPeriodManual: "Les dates incluent des jours fermés par le propriétaire.",
    noAvailForDates: "Aucune disponibilité pour ces dates.",
    selectRoomType: "Sélectionnez un type de chambre.",
    selectValidDates: "Sélectionnez des dates valides.",
    enterGuestName: "Indiquez le nom du voyageur.",
    invalidEmail: "L'e-mail n'est pas valide.",
    enterValidPhone: "Indiquez un téléphone valide.",
    noAvailCreateModify: "Aucune disponibilité pour créer/modifier avec ces dates.",
    aRoom: "une chambre",
    notEnoughAvailIn: "Disponibilité insuffisante dans : {names}.",
    missingOnCreate: "onCreateReservation est manquant dans le composant parent.",
    aRoomType: "un type de chambre",
    notEnoughAvailInType: `Disponibilité insuffisante dans "{name}".`,
    sameHotelOnly: "Une réservation ne peut pas mélanger des chambres de deux hôtels. Retirez celles qui ne sont pas de cet hôtel.",
    otherHotelLinesDropped: "Les chambres de l’hôtel précédent ont été retirées : une réservation ne concerne qu’un seul hôtel.",
    partiallyCreated: "{ok} chambres sur {total} ont été créées et la suivante a échoué. Vérifiez la réservation avant de réessayer.",
    reservationIdNotFound: "ID de réservation introuvable.",
    cannotRemoveAll: "Vous ne pouvez pas retirer toutes les chambres. Pour cela, annulez la réservation complète.",
    thisRoom: "cette chambre",
    confirmRemoval:
      "Vous allez RETIRER de la réservation : {names}. Ces chambres sont libérées et ne sont plus facturées. Continuer et enregistrer ?",
    couldNotAdd: "Impossible d'ajouter {name}.",
    couldNotUpdate: `Impossible de mettre à jour "{name}".`,
    couldNotRemove: `Impossible de retirer "{name}".`,
    couldNotRemovePrimary: "Impossible de retirer la chambre principale.",
    reservationUpdated: "Réservation mise à jour avec succès",
    updatedPartially: "Seule une partie a été enregistrée : vérifiez les chambres de la réservation.",
    couldNotUpdateReservation: "Impossible de mettre à jour la réservation.",
  },
};
